<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="身份：">
        <el-select v-model="query.CLevel" placeholder="请选择" clearable size="small">
          <el-option :label="item.name" :value="item.level" v-for="item in standingList" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="带教老师身份：">
        <el-select v-model="query.techInfoLevelIdForBig" placeholder="请选择" clearable size="small">
          <el-option v-for="(item,index) in technicalServiceLevel" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="加入大客户时间：">
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import clientListApi from '@/api/client/clientList'
import customerLevelApi from '@/api/sys/customerLevel'
import technicalServiceLevelApi from '@/api/sys/technicalServiceLevel'
export default {
  props: ['isIntegral'],
  data() {
    return {
      dateTime: [],
      list: [],
      total: 0,
      listLoading: true,
      query: {
      },
      standingList: [],
      technicalServiceLevel: []
    }
  },
  created() {
    this.getStandingList()
    this.getSeviceList()
  },
  methods: {
    getSeviceList() {
      technicalServiceLevelApi.fetchList({pageNo:1,pageSize:1000,isBigCustomer: true}).then(({ data }) => {
        this.technicalServiceLevel = data.list
      })
    },
    // 获取客户身份
    getStandingList() {
      customerLevelApi.fetchList({ type: 3 }).then(({ data }) => {
        this.standingList = data
      })
    },
    handleDownload() {
      let query = { ...this.query }
      query.bigStartTimeStart = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : ""
      query.bigStartTimeEnd = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : ""
      return this.$common.confirm('是否确认导出')
        .then(() => clientListApi.exportBigExcels(query)).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 1000)
          }
        })
    },

  }

}
</script>

<style>
</style>
